import { render, staticRenderFns } from "./header.vue?vue&type=template&id=07bc1b15&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=07bc1b15&scoped=true&lang=scss&"
import style1 from "./header.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc1b15",
  null
  
)

component.options.__file = "header.vue"
export default component.exports